import cn from 'classnames';
import { FC } from 'react';

import { Icon } from '../Icon';
import { AlertProps } from './Alert.types';
import S from './styles.module.scss';

export const Alert: FC<AlertProps> = ({ children, className }) => {
    return (
        <div className={cn(S.alert, className)}>
            <Icon name="warning" size={15} />
            <div className="alert__content">{children}</div>
        </div>
    );
};
